// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__34bUR","title":"InfoRow_title__1Roiq"};